import React from 'react'
import "./awards.scss"
import ListOfAwards from './listOfAwards'
import SectionAwards from './sectionAwards'
import Letsgo from "../connectors/letsgo";


function Awards() {
  return (
    <div className='container-awards'>
        <div className='section-awards'>
            <SectionAwards />
        </div>
        <div className='section-list-of-awards'>
            <ListOfAwards />
        </div>
        <div className="section-letsgo">
        <Letsgo />
        </div>
    </div>
  )
}

export default Awards